import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import { Button, Grid } from "@mui/material";
import { callAPI } from "../../../../../App/Helpers/callApi";
import Signifier from "../../../../../App/Components/Signifier/Signifier";
import { useSelector } from "react-redux";
import { selectCareersClientValue } from "../../../../../App/State/Slices/SelectedCareersClientSlice";
import { selectUserPermissionsValue } from "../../../../../App/State/Slices/UserPermissionsSlice";
import DraggableTable from "../../../../../App/Components/Table/DraggableTable";
import DropdownComponent from "../../../../../App/Components/Dropdown/DropdownComponent";
import {
  editTalentNetworkDisplay,
  getTalentNetworkDisplay,
} from "./TalentNetworkDisplayService";
import TalentNetworkDisplayTableCell from "./TalentNetworkDisplayTableCell";
import { CheckRoleForClient } from "../../../../../App/Helpers/PermissionsChecks";
import { Roles } from "../../../../../App/Enums/Roles";
import { SignalCellularNull } from "@mui/icons-material";

function TalentNetworkDisplayPage() {
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "80%",
      marginBottom: "50px",
      [theme.breakpoints.down("md")]: {
        width: "100%",
      },
    },
    error: {
      color: theme.palette.error.main,
    },
  }));

  const classes = useStyles();

  const selectCareersClient = useSelector(selectCareersClientValue);
  const rolesObject = useSelector(selectUserPermissionsValue);
  const [showSignifier, setShowSignifier] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [showError, setShowError] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [templates, setTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState("");

  const [customFields, setCustomFields] = useState([]);

  const columns = [
    { label: "Selected", propName: "selected" },
    { label: "Admin Text", propName: "propertyAdminText" },
    { label: "Display Label", propName: "" },
    { label: "Display Placeholder", propName: "" },
    { label: "Help Text", propName: "" },
    { label: "", propName: "" },
  ];

  const getData = () => {
    setLoading(true);
    getTalentNetworkDisplay(selectCareersClient.id).then((response) => {
      setTemplates(response.templates);
      setCustomFields(response.customFieldTypes);
      response.properties.forEach((row) => {
        row.customFields = response.customFieldTypes;
        row.selected =
          row.clientTalentNetworkPropertyConfigurations?.length > 0;
        row.label =
          row.clientTalentNetworkPropertyConfigurations[0]?.labelText ===
          undefined
            ? ""
            : row.clientTalentNetworkPropertyConfigurations[0]?.labelText;
        row.placeholder =
          row.clientTalentNetworkPropertyConfigurations[0]?.placeholderText ===
          undefined
            ? ""
            : row.clientTalentNetworkPropertyConfigurations[0]?.placeholderText;
        row.help =
          row.clientTalentNetworkPropertyConfigurations[0]?.helpText ===
          undefined
            ? ""
            : row.clientTalentNetworkPropertyConfigurations[0]?.helpText;
        row.customId =
          row.clientTalentNetworkPropertyConfigurations[0]
            ?.customFieldTypeId === undefined
            ? -1
            : row.clientTalentNetworkPropertyConfigurations[0]
                ?.customFieldTypeId;
      });
      setTableData(response.properties);
      setLoading(false);
    });
  };

  function addCustomField() {
    var newField = {
      help: "",
      label: "",
      placeholder: "",
      propertyAdminText: "Custom Field",
      propertyName: "customfield",
      selected: true,
      customFields: customFields,
      customId: 1,
    };

    var temp = [...tableData];
    temp.push(newField);
    setTableData(temp);
  }

  function saveTalentNetwork() {
    var addProperties = [];

    var priorityOrder = -1;
    var newOrder = 4;
    var areaFound = false;
    var fail = false;
    tableData.forEach((row) => {
      if (!row.selected && row.propertyName === "emailaddress") {
        setErrorMessage("Email Address must be selected");
        fail = true;
      }
      if (row.selected) {
        if (
          row.label === "" &&
          row.placeholder === "" &&
          row.propertyName !== "isuserinternal"
        ) {
          setErrorMessage(
            "You must assign either the Label Text or the Placeholder Text"
          );
          fail = true;
        }
        if (
          row.propertyName === "areaofinterest" ||
          row.propertyName === "locationbasedareaofinterest"
        ) {
          if (areaFound) {
            setErrorMessage(
              "Only one Area of Interest selection is allowed. Please deselect one."
            );
            fail = true;
          }
          areaFound = true;
        }

        if (row.propertyName === "emailaddress") {
          priorityOrder = 1;
        } else if (row.propertyName === "areaofinterest") {
          priorityOrder = 2;
        } else if (row.propertyName === "locationbasedareaofinterest") {
          priorityOrder = 2;
        } else if (row.propertyName === "optin") {
          priorityOrder = 3;
        }

        let newProperty = {
          AvailableTalentNetworkPropertyId: row.id,
          ClientId: selectCareersClient.id,
          LabelText: row.label,
          PlaceholderText: row.placeholder,
          HelpText: row.help,
          CustomFieldTypeId: row.customId === -1 ? null : row.customId,
          Order: priorityOrder !== -1 ? priorityOrder : newOrder,
          id:
            row.clientTalentNetworkPropertyConfigurations === undefined ||
            row.clientTalentNetworkPropertyConfigurations.length === 0
              ? undefined
              : row.clientTalentNetworkPropertyConfigurations[0].id,
        };
        if (priorityOrder === -1) {
          newOrder += 1;
        }
        priorityOrder = -1;
        addProperties.push(newProperty);
      }
    });

    if (fail === false) {
      let data = {
        ClientId: selectCareersClient.id,
        selectedProperties: addProperties,
        templateId: selectedTemplate.id,
      };

      callAPI(
        editTalentNetworkDisplay(selectCareersClient.id, data),
        "Talent Network Display Saved",
        setShowSignifier,
        setResponseMessage,
        setShowError,
        setProcessing
      ).then(() => {
        getData();
      });
    } else {
      setShowSignifier(true);
      setShowError(true);
    }
  }

  useEffect(() => {
    if (selectCareersClient !== null) {
      getData();
    }
  }, [selectCareersClient]);

  return (
    <>
      <Signifier
        showSignifier={showSignifier}
        setShowSignifier={setShowSignifier}
        message={responseMessage}
        error={showError}
        errorMessage={errorMessage}
      />
      <div className={classes.root}>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={12}>
            <Button
              sx={{
                marginBottom: "10px",
                marginRight: "20px",
              }}
              type="submit"
              variant="contained"
              color="primary"
              onClick={() => addCustomField()}
            >
              Add Custom Field
            </Button>
            <Button
              sx={{
                marginBottom: "10px",
                marginRight: "20px",
              }}
              type="submit"
              variant="contained"
              color="primary"
              onClick={() => saveTalentNetwork()}
            >
              Save
            </Button>
          </Grid>
          {CheckRoleForClient(
            rolesObject,
            selectCareersClient.id?.toUpperCase(),
            Roles.SuperAdmin
          ) ? (
            <Grid item xs={12} sm={3}>
              <DropdownComponent
                currValue={selectedTemplate}
                items={templates}
                property="name"
                title="Assign To Template"
                handleChange={(value) => setSelectedTemplate(value)}
              />
            </Grid>
          ) : null}
          <DraggableTable
            columns={columns}
            tableData={tableData}
            setTableData={setTableData}
            rowComponent={TalentNetworkDisplayTableCell}
            loading={loading}
          />
        </Grid>
      </div>
    </>
  );
}

export default TalentNetworkDisplayPage;
